import "./index.css";
import "@mantine/tiptap/styles.css";

import { ErrorBoundary, Provider } from "@rollbar/react";
import { Provider as ReduxProvider } from "react-redux";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import rollbar from "utils/rollbar";
import { store } from "./redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// import "./applyDomainClass.js";

function ErrorBoundaryLayout({ children }: any) {
    try {
        return children;
    } catch (err: any) {
        console.error("Render error:", err);
        return (
            <div style={{ padding: 20, color: "red" }}>
                App crashed: {err.message}
            </div>
        );
    }
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);
root.render(
    <React.StrictMode>
        <ErrorBoundaryLayout>
            <QueryClientProvider client={queryClient}>
                <Provider instance={rollbar}>
                    <ErrorBoundary>
                        <ReduxProvider store={store}>
                            <App />
                        </ReduxProvider>
                    </ErrorBoundary>
                </Provider>
            </QueryClientProvider>
        </ErrorBoundaryLayout>
    </React.StrictMode>,
);
